function timestampToTime(timestamp) { //时间戳转时间
  // 时间戳为10位需*1000，时间戳为13位不需乘1000
  var date = '';
  if (String(timestamp).length == 10) {
    date = new Date(timestamp * 1000)
  } else {
    date = new Date(timestamp)
  }
  var Y = date.getFullYear() + "年";
  var M =
    (date.getMonth() + 1 < 10 ?
      "0" + (date.getMonth() + 1) :
      date.getMonth() + 1) + "月";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日";
  var h = date.getHours() < 10 ? "0" + date.getHours() + "时" : date.getHours() + "时";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + "分" : date.getMinutes() + "分";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() + "秒" : date.getSeconds() + "秒";
  
  
  return Y + M + D;
  // return Y + M + D + h + m + s;
}




export default {
  timestampToTime,
}



//////////////////
// WEBPACK FOOTER
// ./common/uni-seal.js
// module id = null
// module chunks = 